// Unified inbox hook — actionable work only: approvals + blocked briefs

import {
  selectInboxBadgeCount,
  selectInboxItems,
  type InboxItem,
} from "../lib/inbox-selectors";
import { useOperatorWork } from "./useOperatorWork";
import type { OperatorWorkStatus } from "../../../shared/types";

export type { InboxItem } from "../lib/inbox-selectors";

function inboxStatus(isError: boolean, status: OperatorWorkStatus | undefined): OperatorWorkStatus {
  return isError ? "error" : status ?? "ok";
}

export function useInbox(brandId: string | undefined) {
  const { data: operatorWork, isError, isLoading, refetch } = useOperatorWork(brandId);

  const items = selectInboxItems({
    brandId,
    operatorWorkItems: operatorWork?.items,
  });

  return {
    items,
    isLoading,
    refetch,
    status: inboxStatus(isError, operatorWork?.status),
  };
}

export function useInboxBadgeCount(brandId: string | undefined) {
  const { data: operatorWork, isError } = useOperatorWork(brandId);

  return {
    count: selectInboxBadgeCount({
      brandId,
      operatorWorkItems: operatorWork?.items,
    }),
    status: inboxStatus(isError, operatorWork?.status),
  };
}
